import { render, staticRenderFns } from "./HighlightsItem.vue?vue&type=template&id=85f9a76c&scoped=true"
import script from "./HighlightsItem.vue?vue&type=script&lang=js"
export * from "./HighlightsItem.vue?vue&type=script&lang=js"
import style0 from "./HighlightsItem.vue?vue&type=style&index=0&id=85f9a76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f9a76c",
  null
  
)

export default component.exports